import { render, staticRenderFns } from "./thirdindex.vue?vue&type=template&id=a0e8ae34&scoped=true"
import script from "./thirdindex.vue?vue&type=script&lang=js"
export * from "./thirdindex.vue?vue&type=script&lang=js"
import style0 from "./thirdindex.vue?vue&type=style&index=0&id=a0e8ae34&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0e8ae34",
  null
  
)

export default component.exports